import MultiSelect from 'primevue/multiselect'
import SrInputNumber from '@/components/SrInputNumber.vue'
import { i18n } from '@/i18n'
import { markRaw } from 'vue'
import { z } from 'zod'
import { FUNDING_GROUP_EXCHANGES } from '@/utils/consts'
import InputText from 'primevue/inputtext'
import capitalize from 'lodash/capitalize'
import isString from 'lodash/isString'

export function createFundingRateSignalsFilters() {
  const { t } = i18n.global
  const filters = [
    {
      header: 'exchanges',
      field: 'exchanges',
      component: markRaw(MultiSelect),
      placeholder: 'Gate, Mexc, Ourbit, Lbank',
      zod: z.string().array().optional().nullable(),
      props: {
        filterMatchMode: 'startsWith',
        showClear: true,
        options: FUNDING_GROUP_EXCHANGES.map((x: string) => {
          return { title: capitalize(x), value: x }
        }),
        optionLabel: 'title',
        optionValue: 'value',
        filter: true,
        emptyFilterMessage: t('emptyMessage'),
      },
    },
    {
      field: 'symbols',
      header: 'symbols',
      component: markRaw(InputText),
      placeholder: 'BTC, BNB, ETH',
      zod: z.string().optional().nullable(),
    },
    {
      field: 'spreadMin',
      header: 'spreadMin',
      component: markRaw(SrInputNumber),
      placeholder: '2.00',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
    {
      field: 'priceSpreadMin',
      header: 'priceSpreadMin',
      component: markRaw(SrInputNumber),
      placeholder: '2.00',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
  ]
  return filters
}
